import React, { useEffect, useState, useRef } from 'react'
// import { GoogleMap, useLoadScript } from '@react-google-maps/api'
import { MapContainer, Marker, Popup, TileLayer, Tooltip } from 'react-leaflet';
// import { addressPoints } from './realworld.10000.js';
import L from "leaflet"
import { HeatmapLayer } from "react-leaflet-heatmap-layer-v3";

const containerStyle = {
  width: '100%',
  height: '305px'
};

function MyMapComponentdash(props) {
  const dashboardMap = Array.isArray(props?.homePageMap) ? props.homePageMap : [];

  const convertedData = dashboardMap.map(item => [
    parseFloat(item.lat),
    parseFloat(item.long),
    item.counts
]);
  const mapRef = useRef();

  const heatmapOptions = {
    radius: 20,
    blur: 20,
    maxZoom: 22,
    minOpacity: 0.5,
    maxOpacity: 1
  };

  return (
    <MapContainer  refs={mapRef}
    center={[7.099097 ,9.2596502]} zoom={2} style={containerStyle}>
      <HeatmapLayer
            fitBoundsOnUpdate
            points={convertedData}
            longitudeExtractor={(point) => point[1]}
            latitudeExtractor={(point) => point[0]}
            key={Math.random() + Math.random()}
            intensityExtractor={(point) => parseFloat(point[2])}
            {...heatmapOptions}
          />
    <TileLayer
      url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    />
  </MapContainer>
  );
}

export default MyMapComponentdash;